import React, { useEffect, useRef, useState } from 'react';
import Div from '../Div';

export default function VideoModal({ videoSrc, bgUrl, variant }) {
  const containerRef = useRef(null);
  const [isVisible, setIsVisible] = useState(true);

  const videoId = videoSrc.split('?v=')[1].trim();
  const baseSrc = `https://www.youtube.com/embed/${videoId}`;
  const autoplaySrc = `${baseSrc}?autoplay=1&mute=1&controls=0&showinfo=0&loop=1&playlist=${videoId}`;

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting);
      },
      {
        threshold: 0.3, // visible if 30% or more is in view
      }
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => {
      if (containerRef.current) {
        observer.unobserve(containerRef.current);
      }
    };
  }, []);

  return (
    <Div
      ref={containerRef}
      className={`cs-video_block ${variant || 'cs-style1'} cs-video_open cs-bg`}
      style={{
        width: '100vw',
        height: '100vh',
        backgroundImage: `url(${bgUrl})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        position: 'relative',
        overflow: 'hidden',
        marginLeft: 'calc(-50vw + 50%)'
      }}
    >
      {isVisible && (
        <iframe
          className="cs-video_iframe"
          src={autoplaySrc}
          title="auto playing video"
          frameBorder="0"
          allow="autoplay; encrypted-media"
          allowFullScreen
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            pointerEvents: 'none'
          }}
        />
      )}
    </Div>
  );
}
